// frontend_react/src/routes/ProtectedRoute.jsx

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import LoadingScreen from "../components/LoadingScreen";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, authLoading } = useLogin();
  const location = useLocation();

  if (authLoading) return <LoadingScreen />;

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
